import {createSlice} from '@reduxjs/toolkit'

const getInitialState = () => ({
  isUserFeedbackAgreed: false,
  eventDetails: null,
  isRecording: null
})

const userFeedbackSlice = createSlice({
  name: 'userFeedback',
  initialState: getInitialState(),
  reducers: {
    setIsUserFeedbackAgreed: (state, action) => {
      state.isUserFeedbackAgreed = action.payload
    },
    setEventDetails: (state, action) => {
      state.eventDetails = action.payload
    },
    setIsRecording: (state, action) => {
      state.isRecording = action.payload
    },
    resetUserFeedback: () => getInitialState()
  }
})

// Export actions
export const {setIsUserFeedbackAgreed, setEventDetails, setIsRecording, resetUserFeedback} = userFeedbackSlice.actions

// Export selectors
export const selectIsUserFeedbackAgreed = (state) => state.userFeedback?.isUserFeedbackAgreed ?? false
export const selectEventDetails = (state) => state.userFeedback?.eventDetails ?? null
export const selectIsRecording = (state) => state.userFeedback?.isRecording ?? null

// Export reducer as default
export default userFeedbackSlice.reducer
